import React from "react";
import "./HotelOffers.css";

const HotelOffers = () => {
  const hotelOffers = [
    {
      id: 1,
      hotel: "Taj Hotels",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/Taj_Hotels_Logo.svg/2560px-Taj_Hotels_Logo.svg.png",
      offer: "UP TO 30% OFF",
      description: "Luxury stays with complimentary breakfast",
      locations: "Mumbai • Delhi • Bangalore • Goa • Jaipur",
      rating: "4.8/5",
      popular: true,
    },
    {
      id: 2,
      hotel: "Marriott",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6e/Marriott_logo_%282019%29.svg/2560px-Marriott_logo_%282019%29.svg.png",
      offer: "BUY 2 GET 1 FREE",
      description: "Premium accommodation with spa access",
      locations: "Global destinations worldwide",
      rating: "4.7/5",
      popular: true,
    },
    {
      id: 3,
      hotel: "Hyatt",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5e/Hyatt_Logo.svg/1280px-Hyatt_Logo.svg.png",
      offer: "FLAT 25% OFF",
      description: "Business class hotels with meeting facilities",
      locations: "Metro cities & business districts",
      rating: "4.6/5",
      popular: false,
    },
    {
      id: 4,
      hotel: "Hilton",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/86/Hilton_Hotels_%26_Resorts_logo.svg/2560px-Hilton_Hotels_%26_Resorts_logo.svg.png",
      offer: "WEEKEND DEAL",
      description: "Family packages with extra bed",
      locations: "Major cities & tourist destinations",
      rating: "4.5/5",
      popular: true,
    },
    {
      id: 5,
      hotel: "Radisson",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/92/Radisson_Hotels_logo.svg/1280px-Radisson_Hotels_logo.svg.png",
      offer: "STARTING AT ₹4,999",
      description: "Comfort stays with airport transfer",
      locations: "Airport locations & city centers",
      rating: "4.3/5",
      popular: false,
    },
    {
      id: 6,
      hotel: "Oberoi",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/db/The_Oberoi_Hotels_%26_Resorts_logo.svg/1280px-The_Oberoi_Hotels_%26_Resorts_logo.svg.png",
      offer: "LUXURY PACKAGE",
      description: "5-star experience with butler service",
      locations: "Delhi • Mumbai • Bangalore • Udaipur",
      rating: "4.9/5",
      popular: true,
    },
    {
      id: 7,
      hotel: "ITC Hotels",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7e/ITC_Hotels_Logo.svg/1280px-ITC_Hotels_Logo.svg.png",
      offer: "BUSINESS SPECIAL",
      description: "Corporate rates with late checkout",
      locations: "Business hubs across India",
      rating: "4.6/5",
      popular: true,
    },
    {
      id: 8,
      hotel: "Lemon Tree",
      logo: "https://upload.wikimedia.org/wikipedia/en/thumb/4/4c/Lemon_Tree_Hotels_logo.svg/1280px-Lemon_Tree_Hotels_logo.svg.png",
      offer: "EARLY BIRD 20% OFF",
      description: "Budget friendly premium stays",
      locations: "Metro & tier 2 cities",
      rating: "4.2/5",
      popular: false,
    },
  ];

  // Fallback SVG for broken images
  const getFallbackSvg = (hotelName) => {
    return `data:image/svg+xml;base64,${btoa(`
      <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="60" height="60" rx="12" fill="#F3F4F5"/>
        <text x="30" y="35" text-anchor="middle" fill="#676A7D" font-family="Arial, sans-serif" font-size="12">${
          hotelName.split(" ")[0]
        }</text>
      </svg>
    `)}`;
  };

  const handleImageError = (e, hotelName) => {
    e.target.src = getFallbackSvg(hotelName);
  };

  return (
    <div className="HotelOffers">
      <div className="HotelOffers-section-header">
        <h2>🏨 Exclusive Hotel Deals</h2>
        <p>Special offers from premium hotel chains</p>
      </div>

      <div className="HotelOffers-scroll-container">
        <div className="HotelOffers-scroll">
          {hotelOffers.concat(hotelOffers).map((offer, index) => (
            <div key={`${offer.id}-${index}`} className="HotelOffers-card">
              {offer.popular && (
                <div className="HotelOffers-popular-badge">Most Popular</div>
              )}

              <div className="HotelOffers-card-header">
                <img
                  src={offer.logo}
                  alt={offer.hotel}
                  className="HotelOffers-logo"
                  onError={(e) => handleImageError(e, offer.hotel)}
                />
                <div className="HotelOffers-hotel-info">
                  <h3>{offer.hotel}</h3>
                  <div className="HotelOffers-rating">
                    <span className="HotelOffers-stars">★★★★★</span>
                    <span className="HotelOffers-rating-text">
                      {offer.rating}
                    </span>
                  </div>
                </div>
              </div>

              <div className="HotelOffers-card-body">
                <div className="HotelOffers-offer-main">
                  <h4>{offer.offer}</h4>
                  <p>{offer.description}</p>
                </div>

                <div className="HotelOffers-locations">
                  <span className="HotelOffers-location-icon">📍</span>
                  <span className="HotelOffers-location-text">
                    {offer.locations}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HotelOffers;
